// SHIP +
const insuranceProductID = '48562416812348';

async function insuranceInCart() {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const data = await response.json();
        const insuranceID = data.items.find(i => Number(i.id) === Number(insuranceProductID));
        return { inCart: Boolean(insuranceID), hasChanges: !Object.keys(insuranceID.properties).some((k) => insuranceID.properties[k] === scpProps[k]) };
    } catch (error) {
        return false;
    }
}

async function cartCount() {
    try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const data = await response.json();
        const count = data.items.length;
        return count;
    } catch (error) {
        return false;
    }
}

async function checkInsurance() {
    const { inCart, hasChanges } = await insuranceInCart();
    const count = await cartCount();
    const shipPlusDenied = sessionStorage.getItem('shipPlusDenied');
    if ((!inCart || hasChanges) && (!shipPlusDenied || shipPlusDenied === 'false') && count > 0) {
        updateItemInCart(insuranceProductID, 1, inCart);
    } else if (inCart && count <= 1) {
        updateItemInCart(insuranceProductID, 0, inCart);
    }
}

checkInsurance();

async function handleInsurance() {
    const checkedValue = document.querySelector('#insurance-toggle:checked')?.value || null;
    const inCart = await insuranceInCart();
    if (checkedValue && !inCart) {
        // handle adding insureance
        updateItemInCart(insuranceProductID, 1);
        sessionStorage.setItem('shipPlusDenied', 'false');

    } else if (!checkedValue && inCart) {
        // handle removeing insurance
        updateItemInCart(insuranceProductID, 0);
        sessionStorage.setItem('shipPlusDenied', 'true');
    }
}

function updateItemInCart(productID, quantity, inCart) {
    let urlEndpoint = 'cart/add.js';
    if (quantity === 0 || inCart) {
        urlEndpoint = 'cart/change.js';
    }
    const url = window.Shopify.routes.root + urlEndpoint;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            'id': productID,
            'quantity': quantity,
            'properties': scpProps
        })
    })
        .then(response => response.json())
        .then(() => {
            window.location.href = '/cart';
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}
